const footerMap = {
	mapContainer : false,
	map : false,
	carousel: false,
	markers : [],
	resetMArkerIcon: false,

	init : function(){
		window.addEventListener('DOMContentLoaded', function() {
			footerMap.mapContainer = document.getElementById('footerMap');
			footerMap.createMap();
			footerMap.addMarkersToMap();
			footerMap.agencySlider();
			footerMap.resetMArkerIcon();
		})
	},

	//Create agency adresses slider
	agencySlider: function(){
		this.carousel = $(".mainFooter__agencies__slider.owl-carousel").owlCarousel({
			nav				: false,
			loop			: true,
			dots			: true,
			items			: 1,
			margin			: 30,
		});

		this.carousel.on('changed.owl.carousel', function(event) {

			footerMap.resetMArkerIcon()

			//Add blue icon to selected marker
			footerMap.markers[event.page.index ].setIcon({
				url:'./wp-content/themes/spikeelabs/images/icon_pin_transport_light.svg', 
				scaledSize: new google.maps.Size(40, 55)
			});

		})
	},

	createMap : function(){
		if( !this.mapContainer ) return
		
		this.map = new google.maps.Map(
			this.mapContainer,
			{
				zoom: 5,
				center: {
					lat: 47.400976,
					lng: 2.4037566
				},
				mapTypeId: 'satellite',
				zoomControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				keyboardShortcuts: false,
			}
		);
	},

	addMarkersToMap : function(){
		if( !this.map ||typeof FOOTER_GMAP_MARKERS === 'undefined' ) return;

		FOOTER_GMAP_MARKERS.forEach((marker, index) => {

			let newMarker = new google.maps.Marker({
				position: marker.pos,
				title: marker.title,
				map: this.map,
				icon: {
					url: './wp-content/themes/spikeelabs/images/icon_pin_transport.svg',
					scaledSize: new google.maps.Size(35, 45)

				}
			});

			//Change marker icon and sychronize with slider when click 
			newMarker.addListener("click", () => {			

				footerMap.carousel.trigger("to.owl.carousel",[ index, 300]);

				this.resetMArkerIcon

				//Add blue icon to selected marker
				newMarker.setIcon({
					url:'./wp-content/themes/spikeelabs/images/icon_pin_transport_light.svg', 
					scaledSize: new google.maps.Size(40, 55)
				});
			});

		
			this.markers.push(newMarker)


		})
		
	},

	//Reset marker icon to default icon
	resetMArkerIcon: function resetIcon() {
		for (var i = 0; i < footerMap.markers.length; i++) {
			footerMap.markers[i].setIcon({
				url:'./wp-content/themes/spikeelabs/images/icon_pin_transport.svg', 
				scaledSize: new google.maps.Size(35, 45)
			});
		}
	}

}

const initFooterMap = function(){
	footerMap.init();
}


